/* unplugin-vue-components disabled */import { render } from "./HelpManual.vue?vue&type=template&id=e5f7aec4&scoped=true"
import script from "./HelpManual.vue?vue&type=script&lang=js"
export * from "./HelpManual.vue?vue&type=script&lang=js"

import "./HelpManual.vue?vue&type=style&index=0&id=e5f7aec4&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f7aec4"]])

export default __exports__